module.exports = __webpack_public_path__ + "img/wagb-screen-4.277df0fe.webp";